export default function withNumberFormat(number: number): number | string {
  if (Intl) {
    return String(Intl.NumberFormat().format(number));
  }
  return number;
}
